/**
 * 功能：“字典”类型数据转换
 * 参数：
 *      dict-class： 字典分类（必填）
 *      dict-class： 字典子项
 */
import { getDictItems } from '@/api/config/DictData.js'

export function initialize(column)
{
  let dictClass = column.dictClass;
  let dictItem = column.dictItem;
  // 请求字典数据（column.dictMap自定义变量，不能和其它变量重名）
  if (typeof (dictClass) != 'undefined')
  {
    if (typeof (dictItem) == 'undefined')
    {
      dictItem = null;
    }
    // 获取字典数据
    column.dictMap = new Map();
    GetDictMap(column, dictClass, dictItem, column.dictMap);
  }
}

export function format(column, value)
{
  let dictMap = column.dictMap;
  // 有字典数据 && 有值
  if (value != null && dictMap)
  {
    let dictValue = dictMap.get(value.toString());
    if (dictValue)
      return dictValue;
  }
  // 无字典数据
  return value;
}

// 获取字典Map
function GetDictMap(column, dictClass, dictItem, dictMap)
{
  // 请求数据
  getDictItems(dictClass, dictItem)
    .then(function (res)
    {
      let resultdata = res.data.data;
      // console.log('111111111', resultdata)
      if (resultdata)
      {
        resultdata.forEach(function (item)
        {
          dictMap.set(item.code, item.name);
        })
        // 重新渲染数据
        column.key += 1;
        return dictMap;
      }
      else
        return null;
    });
  return null;
}



// WEBPACK FOOTER //
// ./src/components/DataTable/DataTableColumn/Slot/Dict.js